<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink='/index'>
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Tariff Tester</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-xs-metro">
        <div class="heading-m">
          <div class="caption">
            <img src="assets/images/pages-icon/rates.png">Tariff Tester
          </div>
          <div class="icon buttons">
            <button class="showButton target-btn" target="1"><img src="assets/images/pages-icon/plus.png"></button>
          </div>
        </div>
        <div class="list-sidebar">
          <div class="boxscroll checkbox-height">
            <div class="form-group">
              <label>Device*</label>
              <ng-select [items]="deviceList" bindLabel="DEVICE_NAME" bindValue="DEVICE_ID"
                         [(ngModel)]="selectedDevice">
              </ng-select>
            </div>
            <div class="form-group">
              <label>Entry date*</label>
              <input type="text"
                     placeholder="Entry Date"
                     [(ngModel)]="entryDate"
                     class="form-control"
                     [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD HH:mm:ss' }"
                     bsDatepicker>
            </div>
            <div class="form-group">
              <label>Exit date*</label>
              <input type="text"
                     placeholder="Exit Date"
                     [(ngModel)]="exitDate"
                     class="form-control"
                     [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD HH:mm:ss' }"
                     bsDatepicker>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" (click)="ShowTariff()">Show Tariff</button>
          </div>
          <div class="form-group">
            <Label>Total Fare : {{tariff.VALUE}}</Label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
